
export class Subscriber {
  public id: string;
  public subscriberID: number;
  public name: string;
  public emailAddress: string;
  public createdDate: string;
  public status: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/shared/subscriber-model.ts